import styled from "@emotion/styled"
import { PText } from "@porsche-design-system/components-react"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { alphaDisabled } from "../alphaDisabled"
import { ValidationMessage } from "../validationMessage/ValidationMessage"

interface FieldWrapperProps extends PropsWithChildren {
	/** shows the label in a lighter color */
	disabled?: boolean
	error?: { message?: string }
	label?: string
	required?: boolean
}

export const FieldWrapper = ({ children, disabled, error, label, required }: FieldWrapperProps) => {
	return (
		<Column>
			{label && (
				<Label $disabled={!!disabled} aria-disabled={disabled ? true : undefined}>
					<PText>
						{label}
						{required && " *"}
					</PText>
				</Label>
			)}
			{children}
			{error?.message && <ValidationMessage message={error.message} />}
		</Column>
	)
}

const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticXs};
`

const Label = styled("div", { shouldForwardProp })<{ $disabled: boolean }>`
	opacity: ${({ $disabled }) => ($disabled ? alphaDisabled : 1)};
`
